import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { Icon } from "@/components/ui/Icon";
import { Logo } from "@/components/ui/Logo";
import { Button } from "@/components/ui/button";
interface StepLeftBlockProps {
  index: number;
  total: number;
  title: string | ReactNode;
  subtitle: string;
  showGuide?: boolean;
  additionalInfo?: ReactNode;
  onNext: () => void;
  onBack: () => void;
  onOpenOkx?: () => void;
}

export const StepLeftBlock = ({
  index,
  total,
  title,
  subtitle,
  showGuide = false,
  additionalInfo = null,
  onNext,
  onBack,
  onOpenOkx,
}: StepLeftBlockProps) => {
  const isFirstStep = index === 0;
  const isLastStep = index === total - 1;

  return (
    <div className="text-neutral-50 flex size-full min-h-0">
      {/* MOBILE */}
      <div className="flex min-h-0 w-full flex-col md:hidden">
        {/* scroll area */}
        <div className="scrollbar-hidden min-h-0 flex-1 overflow-y-auto">
          <div className="mx-auto flex w-full max-w-120 flex-col gap-8">
            {/* основной контент */}
            <div className="flex flex-col gap-6">
              <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
                <Logo />
                {showGuide && (
                  <Button
                    variant="secondary"
                    asChild
                    className="shrink-0 whitespace-nowrap"
                  >
                    <Link
                      to="https://www.youtube.com/watch?v=xvFZjo5PgG0"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Icon name="eye" />
                      Смотреть видео-гайд
                    </Link>
                  </Button>
                )}
              </div>

              <div className="flex flex-col gap-3">
                <div className="fs-300 flex gap-3 font-semibold">
                  <span className="text-neutral-100">Инструкция</span>
                  <span className="text-neutral-200/61">
                    {index + 1}/{total} шаг
                  </span>
                </div>

                <h2 className="fs-600 lg:fs-700 font-bold text-neutral-100">{title}</h2>
                <p className="fs-500 font-bold text-neutral-100">{subtitle}</p>
              </div>
            </div>

            {additionalInfo}

            {isFirstStep && onOpenOkx && (
              <Button
                onClick={onOpenOkx}
                size="lg"
                className="w-full"
              >
                Перейти на OKX
              </Button>
            )}

            {/* чтобы контент не прилипал к футеру */}
            <div className="h-6" />
          </div>
        </div>

        {/* fixed footer */}
        <div className="shrink-0 pt-4 pb-5">
          <div className="mx-auto flex w-full max-w-120 gap-2">
            <Button
              variant="neutral"
              size="lg"
              className="flex-1"
              onClick={onBack}
            >
              Назад
            </Button>
            <Button
              variant="secondary"
              size="lg"
              className="flex-1"
              onClick={onNext}
            >
              {isLastStep ? "Готово" : "Дальше"}
            </Button>
          </div>
        </div>
      </div>

      {/* DESKTOP */}
      <div className="hidden w-full items-center justify-center md:flex">
        <div className="flex w-full max-w-120 flex-col gap-12">
          {/* Text content */}
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-2">
              {/* Header */}
              <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
                <Logo />

                {showGuide && (
                  <Button
                    variant="secondary"
                    asChild
                  >
                    <Link
                      to="https://www.youtube.com/watch?v=xvFZjo5PgG0"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Icon name="eye" />
                      Смотреть видео-гайд
                    </Link>
                  </Button>
                )}
              </div>
            </div>

            <div className="flex flex-col gap-3">
              {/* Instruction header */}
              <div className="fs-300 flex gap-3 font-semibold">
                <span className="text-neutral-100">Инструкция</span>
                <span className="text-neutral-200/61">
                  {index + 1}/{total} шаг
                </span>
              </div>

              {/* Title */}
              <h2 className="fs-700 font-bold text-neutral-100">{title}</h2>

              {/* Subtitle */}
              <p className="fs-500 font-bold text-neutral-100">{subtitle}</p>
            </div>
          </div>

          {/* Additional info */}
          {additionalInfo}

          {/* Buttons */}
          {isFirstStep && onOpenOkx && (
            <Button
              onClick={onOpenOkx}
              size="lg"
              className="w-full"
            >
              Перейти на OKX
            </Button>
          )}

          <div className="flex w-full gap-2">
            <Button
              variant="neutral"
              size="lg"
              className="flex-1"
              onClick={onBack}
            >
              Назад
            </Button>

            <Button
              variant="secondary"
              size="lg"
              className="flex-1"
              onClick={onNext}
            >
              {isLastStep ? "Готово" : "Дальше"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
